
import { Vue, Component, Prop, Model } from "vue-property-decorator";
import VueEasyLightbox from 'vue-easy-lightbox';
import { Portal } from "portal-vue";

@Component({
  components: {
    VueEasyLightbox,
    Portal,
  }
})
export default class EnlargedImageViewer extends Vue {
  @Prop({ type: Array, default: () => []}) readonly images!: string[];
  @Prop({ type: Number, default: undefined}) readonly index?: number;
  @Model('toggleVisible', { type: Boolean, default: false }) readonly visible!: boolean;

  handleHide() {
    this.$emit('toggleVisible', false);
  }
}
